<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !billingWarningForm.id
          ? this.$t('alarms.billing.addBillingAlarm')
          : this.$t('alarms.billing.editBillingAlarm')
      "
      :loading="loading"
      :mask-closable="false"
      width="900px"
      :styles="{ top: '65px' }"
    >
      <Form
        ref="billingWarningForm"
        :model="billingWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 微信警告 -->
        <wechat-warning
          v-if="wechatWarningVisible"
          ref="wechatWarning"
        ></wechat-warning>
        <!-- 云平台 -->
        <FormItem
          :label="this.$t('alarms.billing.cloudType')"
          prop="accountTypeSearchKey"
        >
          <Select
            v-model="billingWarningForm.accountTypeSearchKey"
            filterable
            @on-change="
              searchAccountType(billingWarningForm.accountTypeSearchKey)
            "
            :transfer="true"
            style="width: 300px"
          >
            <Option
              :value="item.id"
              v-for="item in accountTypeList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 规则名称 -->
        <FormItem
          :label="this.$t('alarms.billing.alertRuleName')"
          prop="ruleName"
          v-if="isEditRuleName"
        >
          <Row>
            <Col span="11">
              <Input
                type="text"
                v-model="billingWarningForm.ruleName"
                placeholder="Enter something..."
                style="width: 300px"
                :disabled="isEdit"
              ></Input>
            </Col>
          </Row>
        </FormItem>

        <!-- 规则名称 -->
        <FormItem
          :label="this.$t('alarms.billing.alertRuleName')"
          v-if="showRuleName"
        >
          <Row>
            <Col span="24">
              <div>{{ this.billingWarningForm.ruleName }}</div>
            </Col>
          </Row>
        </FormItem>

        <!-- 类型 -->
        <FormItem :label="this.$t('alarms.billing.type')" prop="types">
          <RadioGroup
            v-model="billingWarningForm.types"
            @on-change="changeTypes"
          >
            <Radio
              v-for="list in this.billingWarningForm.accountTypeSearchKey == 0
                ? typesList
                : this.billingWarningForm.accountTypeSearchKey == 4
                ? typesList
                : this.billingWarningForm.accountTypeSearchKey == 1
                ? typeAliyunList
                : vmwareList"
              :label="list.types"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>

        <!---       单账户       -->
        <div v-if="billingWarningForm.types == 0">
          <!-- 账户 -->
          <FormItem :label="this.$t('alarms.billing.account')" prop="account">
            <Select
              v-model="billingWarningForm.account"
              style="width: 300px"
              @on-change="changeAccount(billingWarningForm.account)"
              :transfer="true"
              :placeholder="this.$t('alarms.common.pleaseSelect')"
            >
              <Option
                :value="item.id"
                v-for="item in accountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 存储区域 -->
          <FormItem
            :label="this.$t('alarms.billing.region')"
            prop="backupRegion"
          >
            <Select
              v-model="billingWarningForm.backupRegion"
              style="width: 300px"
              multiple
              :max-tag-count="1"
              :transfer="true"
              @on-change="changebackupRegion(billingWarningForm.backupRegion)"
              :placeholder="this.$t('alarms.common.pleaseSelect')"
            >
              <Checkbox
                v-model="singleBackupRegion"
                @on-change="selectBackupRegionAll"
                style="display: block; text-align: right"
                >{{ $t("alarms.common.all") }}</Checkbox
              >
              <Option
                :value="item.name"
                v-for="item in backupRegionList"
                :key="item.name"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <!---       账户组       -->
        <div v-else-if="billingWarningForm.types == 1">
          <!-- 账户组 -->
          <FormItem
            :label="this.$t('alarms.billing.accountGroup')"
            prop="accountGroupName"
          >
            <Select
              v-model="billingWarningForm.accountGroupName"
              style="width: 300px"
              @on-change="changeAccountGroup(billingWarningForm.account)"
              :transfer="true"
              :placeholder="this.$t('alarms.common.pleaseSelect')"
            >
              <Option
                :value="item.id"
                v-for="(item, index) in accountGroupList"
                v-bind:key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <!-- 资源类型 -->
        <FormItem
          :label="this.$t('alarms.billing.resourceType')"
          prop="resourceType"
        >
          <Select
            v-model="billingWarningForm.resourceType"
            style="width: 300px"
            :transfer="true"
            @on-change="
              handleChangeResourceType(billingWarningForm.resourceType)
            "
          >
            <Option
              :value="item.id"
              v-for="item in resourceTypeList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 规则描述 -->
        <FormItem :label="this.$t('alarms.billing.alertRuleDesc')">
          <Row :gutter="4">
            <!-- 监控指标 -->
            <Col span="4">
              <FormItem prop="monitorIndex">
                <Select
                  v-model="billingWarningForm.monitorIndex"
                  @on-change="
                    changeMonitorIndex(billingWarningForm.monitorIndex)
                  "
                  :placeholder="this.$t('alarms.common.pleaseSelect')"
                >
                  <Option
                    :value="item.id"
                    v-for="item in monitorIndexList"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 周期 -->
            <Col span="3">
              <FormItem prop="cycle">
                <Select
                  v-model="billingWarningForm.cycle"
                  :placeholder="this.$t('alarms.common.cycle')"
                  @on-change="changeCycle(billingWarningForm.cycle)"
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in cycleList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 连续周期 -->
            <Col span="4">
              <FormItem prop="continousCycle">
                <Select
                  v-model="billingWarningForm.continousCycle"
                  :placeholder="this.$t('alarms.common.continuous')"
                  @on-change="
                    changeContinousCycle(billingWarningForm.continousCycle)
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in continousCycleList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 统计数值 -->
            <Col span="3">
              <FormItem prop="statisticsValue">
                <Select
                  v-model="billingWarningForm.statisticsValue"
                  :placeholder="this.$t('alarms.common.pleaseSelect')"
                  @on-change="
                    changeStatisticsValue(billingWarningForm.statisticsValue)
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in statisticsValueList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>

            <!-- 检测周期 -->
            <div v-if="billingWarningForm.monitorIndex === 1539 || billingWarningForm.monitorIndex === 1540">
              <Col span="3">
                <FormItem prop="checkCycle">
                  <div style="display: flex;align-items: center;">
                    <InputNumber :max="30" :min="1" v-model="billingWarningForm.checkCycle" :placeholder="this.$t('alarms.common.checkCycle')" style="width: 60px;"></InputNumber>
                    {{this.$t('configuration_management.schedules.day')}}
                    <Tooltip :content="this.$t('alarms.common.tips')" placement="top" :max-width="200" transfer>
                      <Icon type="ios-alert" size="16" />
                    </Tooltip>
                  </div>
                </FormItem>
              </Col>
            </div>

            <!-- 如果监控指标为RI匹配时 不显示符号、阈值和单位 -->
            <div v-if="this.isShowField != 1">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select
                    v-model="billingWarningForm.relationshipSign"
                    @on-change="
                      changeRelationshipSign(
                        billingWarningForm.relationshipSign
                      )
                    "
                    :placeholder="this.$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <!-- 阈值 -->
              <Col span="3" v-if="billingWarningForm.monitorIndex == 16">
                <FormItem prop="thresholdValue">
                  <Input
                    v-model="billingWarningForm.thresholdValue"
                    disabled
                    :placeholder="this.$t('alarms.common.threshold')"
                    type="number"
                  ></Input>
                </FormItem>
              </Col>

              <!-- 阈值 -->
              <Col span="5" v-else-if="billingWarningForm.monitorIndex == 40">
                <div v-if="!billingWarningForm.id">
                  <FormItem prop="thresholdValues">
                    <Select
                      v-model="billingWarningForm.thresholdValues"
                      filterable
                      multiple
                      allow-create
                      @on-create="handleCreate"
                      :placeholder="this.$t('alarms.common.threshold')"
                      @input="limitcount"
                    >
                      <Option
                        v-for="item in thresholdValuesList"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</Option
                      >
                    </Select>
                  </FormItem>
                </div>
                <div v-else>
                  <FormItem prop="thresholdValues">
                    <Select
                      v-model="billingWarningForm.thresholdValues"
                      filterable
                      multiple
                      allow-create
                      @on-create="handleCreate"
                      :placeholder="this.$t('alarms.common.threshold')"
                      @input="limitcount"
                      disabled
                    >
                      <Option
                        v-for="item in thresholdValuesList"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</Option
                      >
                    </Select>
                  </FormItem>
                </div>
              </Col>

              <!-- 波动率 -->
              <Col span="2" v-else-if="billingWarningForm.monitorIndex === 1539 || billingWarningForm.monitorIndex === 1540">
                <FormItem prop="thresholdValue">
                  <InputNumber
                    :min="0"
                    :max="100"
                    v-model="billingWarningForm.thresholdValue"
                    :placeholder="this.$t('alarms.common.volatility')"
                    style="width: 60px;"
                  ></InputNumber>
                </FormItem>
              </Col>

              <!-- 阈值 -->
              <Col span="3" v-else>
                <FormItem prop="thresholdValue">
                  <Input
                    v-model="billingWarningForm.thresholdValue"
                    :placeholder="this.$t('alarms.common.threshold')"
                    type="number"
                  ></Input>
                </FormItem>
              </Col>

              <!-- 单位 -->
<!--              <Col span="2">-->
<!--                <FormItem prop="unit">-->
<!--                  <Input-->
<!--                    v-model="billingWarningForm.unit"-->
<!--                    disabled-->
<!--                    :placeholder="this.$t('alarms.common.unit')"-->
<!--                  ></Input>-->
<!--                </FormItem>-->
<!--              </Col>-->
              {{billingWarningForm.unit}}
              <span v-if="billingWarningForm.monitorIndex === 1541">
                <Tooltip :content="this.$t('alarms.common.tooltips')" placement="top" :max-width="200" transfer>
                  <Icon type="ios-alert" size="16" />
                </Tooltip>
              </span>
            </div>
            <div v-else-if="this.isShowField == 2">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select
                    v-model="billingWarningForm.relationshipSign"
                    @on-change="
                      changeRelationshipSign(
                        billingWarningForm.relationshipSign
                      )
                    "
                    :placeholder="this.$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 阈值 -->
              <Col span="2">
                <FormItem prop="thresholdValue">
                  <Input
                    v-model="billingWarningForm.thresholdValue"
                    :placeholder="this.$t('alarms.common.threshold')"
                    type="number"
                  ></Input>
                </FormItem>
              </Col>
              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input
                    v-model="billingWarningForm.unit"
                    disabled
                    :placeholder="this.$t('alarms.common.unit')"
                  ></Input>
                </FormItem>
              </Col>
            </div>
          </Row>
        </FormItem>

        <!-- 审批流 -->
        <FormItem
          :label="this.$t('alarms.billing.approval')"
          prop="approvalFlow"
          v-if="
            billingWarningForm.monitorIndex == 36 ||
              billingWarningForm.monitorIndex == 40
          "
        >
          <Select
            v-model="billingWarningForm.approvalFlow"
            style="width: 300px"
            :transfer="true"
            :placeholder="this.$t('alarms.common.pleaseSelect')"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in approvalFlowList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 联系方式 -->
        <FormItem
          :label="this.$t('alarms.billing.contactWay')"
          prop="contactType"
        >
          <RadioGroup
            v-model="billingWarningForm.contactType"
            @on-change="changeContactType(billingWarningForm.contactType)"
          >
            <Radio
              v-for="item in contactTypeList"
              :label="item.type"
              :key="item.value"
              >{{ item.label }}</Radio
            >
          </RadioGroup>
        </FormItem>

        <!-- 通知对象 -->
        <FormItem
          :label="this.$t('alarms.common.contact')"
          prop="notificationObject"
          v-if="billingWarningForm.contactType == 0"
        >
          <Select
            v-model="billingWarningForm.notificationObject"
            multiple
            style="width: 300px"
            @on-change="changeNotificationObject"
            :placeholder="this.$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in notificationObjectList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 联系人组 -->
        <FormItem
          :label="this.$t('alarms.billing.contactGroup')"
          prop="contactGroupIds"
          v-if="billingWarningForm.contactType == 1"
        >
          <Select
            v-model="billingWarningForm.contactGroupIds"
            multiple
            style="width: 300px"
            @on-change="
              changeContactGroupId(billingWarningForm.contactGroupIds)
            "
            :placeholder="this.$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in contactGroupIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 报警方式 -->
        <FormItem :label="this.$t('alarms.common.alarmType')" prop="noticeType">
          <Select
            v-model="billingWarningForm.noticeType"
            multiple
            style="width: 300px"
            @on-change="selectnoticeType(billingWarningForm.noticeType)"
            :placeholder="this.$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in alarmWayList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 企业微信机器人URL -->
        <FormItem
          :label="$t('alarms.common.enterpriseWeChatRobotURL')"
          prop="enterpriseWechatRobotIds"
          v-if="
            billingWarningForm.noticeType.filter(function(e) {
              return e == 3;
            }).length != 0
          "
        >
          <Select
            v-model="billingWarningForm.enterpriseWechatRobotIds"
            multiple
            style="width: 300px"
            :placeholder="$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in enterpriseWechatRobotIdsList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 延迟告警 -->
        <FormItem
          :label="this.$t('alarms.common.delayAlarm')"
          prop="alarmDelay"
        >
          <Select
            v-model="billingWarningForm.alarmDelay"
            style="width: 300px"
            :placeholder="this.$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in alarmDelayList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 监控时段 -->
        <FormItem
          :label="this.$t('alarms.common.monitoringTime')"
          prop="monitorPeriod"
        >
          <Select
            v-model="billingWarningForm.monitorPeriod"
            style="width: 300px"
            :placeholder="this.$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in monitorPeriodList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 邮箱模板 -->
        <div v-show="isShowEmail">
          <FormItem
            :label="this.$t('alarms.common.emailTemplate')"
            prop="emailModal"
          >
            <Input
              v-model="billingWarningForm.emailModal"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              style="width: 665px"
              disabled
            ></Input>
          </FormItem>
        </div>

        <!-- 企业微信模板 -->
        <div v-show="isShowWeChat">
          <FormItem
            :label="this.$t('alarms.common.weChatTemplate')"
            prop="wechatModal"
          >
            <Input
              v-model="billingWarningForm.wechatModal"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              style="width: 665px"
              disabled
            ></Input>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button size="large" @click="cancel('billingWarningForm')">{{
          $t("alarms.common.cancel")
        }}</Button>
        <Button
          type="primary"
          size="large"
          @click="ok('billingWarningForm')"
          :loading="addloading"
          :disabled="isAddOrEdit"
        >
          {{
            !billingWarningForm.id
              ? this.$t("common.addAlarm")
              : this.$t("common.editAlarm")
          }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import WechatWarning from "../common/WechatWarning.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import { filterOutDeprecatedMetrics } from "../../../utils/deprecatedMetrics.js";
var tableBillingWarningVue = {};
export default {
  inject: ["reload"],
  components: {
    WechatWarning
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.alertRule
        .nameRepeatedCheck({
          alertRuleName: this.billingWarningForm.ruleName,
          monitorModule: this.monitorModule
        })
        .then(res => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch(err => {
          if (err.status == 400) {
            callback(new Error(this.$t("alarms.billing.rule.ruleNameDuplicate")));
          }
        });
    };
    // 当监控指标为“自动购买预留实例”时 阈值要满足1-6个数字至少有一个大于七 换种实现方式为“第一个阈值必需要大于7” 则满足以上需求
    const validKeyWordsRule = (rule, value, callback, options) => {
      if (value[0] < 7) {
        callback(new Error(this.$t("alarms.billing.rule.firstThresholdGreaterThan7")));
      } else {
        callback();
      }
    };

    return {
      monitorModule: 2,
      companyId: getCookie(global.companyId),
      addloading: false,
      isAddOrEdit: true,
      wechatWarningVisible: false,
      contactTypeList: [
        {
          label: this.$t("alarms.billing.contact"),
          value: "contact",
          type: 0
        },
        {
          label: this.$t("alarms.billing.contactGroup"),
          value: "contactGroup",
          type: 1
        }
      ],
      singleBackupRegion: false,
      accountTypeList: [],
      accountGroupList: [],
      alarmDelayList: [],
      monitorPeriodList: [],
      isEdit: false,
      bo: false,
      num: 0,
      isEditRuleName: false,
      showRuleName: false,
      isShowField: "",
      isShowEmail: false,
      isShowWeChat: false,
      selection: [],
      accountList: [],
      notificationObjectList: [],
      backupRegionList: [],
      loading: true,
      modal: false,
      units: "",
      exportDataList: "",
      noticeType: [],
      alarmWayList: [],
      unit: "",
      approvalFlowList: [],
      billingWarningForm: {
        account: [],
        accountGroupName: "",
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        relationshipSign: "",
        unit: "",
        backupRegion: [],
        resourceType: 0,
        alarmDelay: "",
        monitorPeriod: "",
        accountTypeSearchKey: "",
        types: 0,
        thresholdValues: [],
        contactType: 0,
        contactGroupIds: [],
        userIdList: [],
        approvalFlow: "",
        enterpriseWechatRobotIds: [],
        checkCycle: 1
      },
      // 联系人组
      contactGroupIdList: [],
      thresholdValuesList: [],
      enterpriseWechatRobotIdsList: [],
      typesList: [
        {
          label: this.$t("alarms.billing.account"),
          value: "account",
          types: 0
        },
        {
          label: this.$t("alarms.billing.accountGroup"),
          value: "accountGroup",
          types: 1
        }
      ],
      typeAliyunList: [
        {
          label: this.$t("alarms.billing.account"),
          value: "account",
          types: 0
        },
        {
          label: this.$t("alarms.billing.accountGroup"),
          value: "accountGroup",
          types: 1
        }
      ],
      vmwareList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 关系符号
      relationshipSignList: [],
      // 资源类型
      resourceTypeList: [],
      ruleValidate: {
        account: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.account"),
            trigger: "change",
            type: "number"
          }
        ],
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.accountTypeSearchKey"),
            trigger: "change",
            type: "number"
          }
        ],
        alarmDelay: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.alarmDelay"),
            trigger: "change",
            type: "number"
          }
        ],
        monitorPeriod: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.monitorPeriod"),
            trigger: "change",
            type: "number"
          }
        ],
        backupRegion: [
          {
            required: true,
            type: "array",
            message: this.$t("alarms.billing.rule.backupRegion"),
            trigger: "change"
          }
        ],
        types: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.types"),
            trigger: "change",
            type: "number"
          }
        ],
        ruleName: [
          { required: true, message: this.$t("alarms.billing.rule.ruleNameRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("alarms.billing.rule.ruleNamePattern"),
            pattern: "^[^ ]{2,20}$",
            trigger: "blur"
          },
          { validator: validNameRepeatedCheck, trigger: "blur" }
        ],
        notificationObject: [
          { required: true, type: "array", message: this.$t("alarms.billing.rule.notificationObject") }
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: this.$t("alarms.billing.rule.noticeType"),
            trigger: "change"
          }
        ],
        monitorIndex: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.monitorIndex"),
            trigger: "change",
            type: "number"
          }
        ],
        accountGroupName: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.accountGroupName"),
            trigger: "change",
            type: "number"
          }
        ],
        resourceType: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.resourceType"),
            trigger: "change",
            type: "number"
          }
        ],
        cycle: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.cycle"),
            trigger: "change",
            type: "number"
          }
        ],
        continousCycle: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.continousCycle"),
            trigger: "change",
            type: "number"
          }
        ],
        statisticsValue: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.statisticsValue"),
            trigger: "change",
            type: "number"
          }
        ],
        relationshipSign: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.relationshipSign"),
            trigger: "change",
            type: "number"
          }
        ],
        checkCycle: [{ required: true, message: this.$t("alarms.billing.rule.checkCycle"), trigger: "change", type: "number" }],
        thresholdValue: [{ required: false, message: this.$t("alarms.billing.rule.thresholdValue") }],
        thresholdValues: [
          { required: true, type: "array", message: this.$t("alarms.billing.rule.thresholdValues") },
          { validator: validKeyWordsRule }
        ],
        contactType: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.contactType"),
            trigger: "change",
            type: "number"
          }
        ],
        contactGroupIds: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.contactGroupIds"),
            trigger: "change",
            type: "array"
          }
        ],
        approvalFlow: [
          {
            required: true,
            message: this.$t("alarms.billing.rule.approvalFlow"),
            trigger: "change",
            type: "number"
          }
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: this.$t("alarms.billing.rule.enterpriseWechatRobotIds"),
            trigger: "change"
          }
        ]
      }
    };
  },

  beforeCreate() {
    tableBillingWarningVue = this;
  },
  methods: {
    // 控制阈值 最多选择6个阈值
    limitcount(e) {
      if (e.length > 6) {
        this.$Modal.warning({
          title: this.$t("alarms.billing.modal.validationRule"),
          content: this.$t("alarms.billing.modal.maxSixThresholds")
        });
        e.pop();
      }
    },
    // 创建阈值
    handleCreate(val) {
      if (val >= 2 && val <= 60) {
        this.thresholdValuesList.push({
          value: val,
          label: val
        });
      } else {
        this.billingWarningForm.thresholdValues = [];
        this.$Modal.warning({
          title: this.$t("alarms.billing.modal.validationRule"),
          content: this.$t("alarms.billing.modal.riThresholdRange")
        });
      }
    },
    init(id, accountType, companyId) {
      this.billingWarningForm.id = id || 0;
      // 根据用户名查询Account列表

      tableBillingWarningVue.getAccount(accountType);
      tableBillingWarningVue.selectAccountByCloudPlatform(accountType);
      this.$nextTick(() => {
        // 重置表单
        this.$refs["billingWarningForm"].resetFields();
        // 编辑
        if (this.billingWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;

          this.$api.alertRule
            .selectAlertRule("id", this.billingWarningForm.id)
            .then(res => {
              tableBillingWarningVue.searchResourceType(accountType, res.data.resourceType);
              tableBillingWarningVue.billingWarningForm.accountTypeSearchKey =
                res.data.accountType;
              //延时
              this.billingWarningForm.alarmDelay = res.data.delay;
              //监控时段
              this.billingWarningForm.monitorPeriod = res.data.monitorPeriod;

              // 账户
              /******************************************************/
              this.billingWarningForm.account = res.data.accountId;

              // 查询联系人组
              tableBillingWarningVue.listContactGroups();
              tableBillingWarningVue.getAccountGroupList();

              // 存储区域
              tableBillingWarningVue.$api.account
                .queryAccountRegions(
                  "accountId",
                  this.billingWarningForm.account
                )
                .then(res => {
                  this.backupRegionList = res.data;
                });

              tableBillingWarningVue.$api.contact
                .queryContactsByAccountIdAndMonitorModule({
                  monitorModule: this.monitorModule,
                  accountId: this.billingWarningForm.account
                })
                .then(res => {
                  this.notificationObjectList = res.data.contactList;
                });

              setTimeout(() => {
                this.billingWarningForm.backupRegion = res.data.regions;
              }, 1000);

              //类型
              this.billingWarningForm.types = res.data.billingType;
              // 资源类型
              this.billingWarningForm.resourceType = res.data.resourceType;
              // 规则名称
              this.billingWarningForm.ruleName = res.data.alertRuleName;

              tableBillingWarningVue.selectMonitorIndexDefault();
              this.billingWarningForm.monitorIndex = res.data.monitorIndex;
              // 监控指标
              /******************************************************/
              // 如果监控指标为RI匹配时 不显示符号、阈值和单位
              if (
                this.billingWarningForm.monitorIndex == 15 ||
                this.billingWarningForm.monitorIndex == 36 ||
                this.billingWarningForm.monitorIndex == 341
              ) {
                this.isShowField = 1;
              } else {
                this.isShowField = 2;
              }

              // 如果监控指标为EIP没有EC2attached 或者 自动购买预留实例时 查询审批流
              if (
                this.billingWarningForm.monitorIndex == 36 ||
                this.billingWarningForm.monitorIndex == 40
              ) {
                // 审批流
                if (companyId == -1 || companyId == undefined) {
                  tableBillingWarningVue.$api.processTemplate
                    .listProcessTemplatesByMetricIndex(
                      "metricIndex",
                      this.billingWarningForm.monitorIndex
                    )
                    .then(res => {
                      this.approvalFlowList = res.data;
                    });
                  this.billingWarningForm.approvalFlow = parseInt(
                    res.data.processTemplateId
                  );
                } else {
                  tableBillingWarningVue.$api.processTemplate
                    .listProcessTemplatesByMetricIndexAndCompanyId({
                      metricIndex: this.billingWarningForm.monitorIndex,
                      companyId: companyId
                    })
                    .then(res => {
                      this.approvalFlowList = res.data;
                    });
                  this.billingWarningForm.approvalFlow = parseInt(
                    res.data.processTemplateId
                  );
                }
              }
              if (this.billingWarningForm.monitorIndex === 1539 || this.billingWarningForm.monitorIndex === 1540) {
                this.billingWarningForm.checkCycle = res.data.checkCycle;
              }
              // 周期
              this.billingWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.billingWarningForm.continousCycle = res.data.continousCycle;
              // 统计数值
              this.billingWarningForm.statisticsValue =
                res.data.statisticsValue;
              // 符号
              this.billingWarningForm.relationshipSign =
                res.data.relationshipSign;
              // 阈值
              this.billingWarningForm.thresholdValue = res.data.thresholdValue;
              this.billingWarningForm.thresholdValues =
                res.data.thresholdValues;
              this.thresholdValuesList = res.data.thresholdValueList;
              // 单位
              this.billingWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;
              // 企业微信机器人URL
              this.billingWarningForm.enterpriseWechatRobotIds =
                res.data.enterpriseWechatRobotIds;

              // 联系方式
              this.billingWarningForm.contactType = res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.billingWarningForm.notificationObject =
                  res.data.contactIDs;
                for (
                  var i = 0;
                  i < this.billingWarningForm.notificationObject.length;
                  i++
                ) {
                  for (var j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.billingWarningForm.notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.billingWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup
                  .listContactGroupsByAccountId(
                    "accountId",
                    this.billingWarningForm.account
                  )
                  .then(res => {
                    this.contactGroupIdList = res.data;
                  });
                setTimeout(() => {
                  this.billingWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }

              // 查询阈值
              tableBillingWarningVue.selectMonitorIndexDefault();

              // 报警方式
              this.billingWarningForm.noticeType = res.data.noticeType;
              for (
                var i = 0;
                i < this.billingWarningForm.noticeType.length;
                i++
              ) {
                if (this.billingWarningForm.noticeType[i] == "0") {
                  this.isShowEmail = true;
                  this.billingWarningForm.emailModal =
                    res.data.briefReportBodyMail;
                  this.noticeType = this.billingWarningForm.noticeType;
                  tableBillingWarningVue.selectTemplate();
                }
                if (this.billingWarningForm.noticeType[i] == "1") {
                  // this.isShowWeChat = true;
                  this.billingWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType = this.billingWarningForm.noticeType;
                  tableBillingWarningVue.selectTemplate();
                } else if (this.billingWarningForm.noticeType[i] != "1") {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
              this.billingWarningForm.accountGroupName =
                res.data.billingList[0].accountGroupId;
            });
        } else {
          this.isEdit = false;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.showRuleName = false;
        }
      });
      this.modal = true;
    },
    // 获取AccountGroup下拉框
    getAccountGroupList() {
      this.accountGroupList = [];
      this.$api.accountGroup
        .getAccountGroupList(getCookie(global.cookieName), this.billingWarningForm.accountTypeSearchKey)
        .then(res => {
          this.accountGroupList = res.data;
        });
    },
    // 清空周期、连续周期、统计数值、关系符号
    /****************************************************************/
    emptyDate() {
      this.billingWarningForm.cycle = "";
      this.billingWarningForm.continousCycle = "";
      this.billingWarningForm.statisticsValue = "";
      this.billingWarningForm.relationshipSign = "";
      this.billingWarningForm.thresholdValue = "";
    },
    isNotEmpty(obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex() {
      // 如果监控指标为RI匹配时 不显示符号、阈值和单位
      if (
        this.billingWarningForm.monitorIndex == 15 ||
        this.billingWarningForm.monitorIndex == 36 ||
        this.billingWarningForm.monitorIndex == 341
      ) {
        this.isShowField = 1;
      } else {
        this.isShowField = 2;
      }
      // 查询阈值
      tableBillingWarningVue.selectMonitorIndexDefault();
      this.unit = this.billingWarningForm.monitorIndex;

      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.unit) {
          this.billingWarningForm.unit = this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableBillingWarningVue.selectTemplate();
      tableBillingWarningVue.emptyDate();
      // 查询当前指标的审批流
      tableBillingWarningVue.listProcessTemplatesByMetricIndex();
    },
    // 查询审批流列表
    listProcessTemplatesByMetricIndex() {
      if (this.billingWarningForm.monitorIndex == undefined) {
        return;
      }
      // 当登录用户为冠闵用户时，查询当前账号所属公司下的审批流列表
      if (
        this.companyId == 1 &&
        this.billingWarningForm.account != null &&
        this.billingWarningForm.account != ""
      ) {
        // get company id by account id
        tableBillingWarningVue.$api.account
          .getCompanyIdByAccountId("accountId", this.billingWarningForm.account)
          .then(res => {
            let companyId = res.data;
            tableBillingWarningVue.$api.processTemplate
              .listProcessTemplatesByMetricIndexAndCompanyId({
                metricIndex: this.billingWarningForm.monitorIndex,
                companyId: companyId
              })
              .then(res => {
                this.approvalFlowList = res.data;
              });
          });
      } else if (this.companyId != 1) {
        // 非冠闵用户
        tableBillingWarningVue.$api.processTemplate
          .listProcessTemplatesByMetricIndex(
            "metricIndex",
            this.billingWarningForm.monitorIndex
          )
          .then(res => {
            this.approvalFlowList = res.data;
          });
      }
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault() {
      tableBillingWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorIndex: this.billingWarningForm.monitorIndex,
          monitorModule: this.monitorModule,
          cycle: this.billingWarningForm.cycle,
          continousCycle: this.billingWarningForm.continousCycle,
          statisticsValue: this.billingWarningForm.statisticsValue,
          relationshipSign: this.billingWarningForm.relationshipSign
        })
        .then(res => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableBillingWarningVue.isNotEmpty(this.billingWarningForm.cycle) &&
            tableBillingWarningVue.isNotEmpty(
              this.billingWarningForm.continousCycle
            ) &&
            tableBillingWarningVue.isNotEmpty(
              this.billingWarningForm.statisticsValue
            ) &&
            tableBillingWarningVue.isNotEmpty(
              this.billingWarningForm.relationshipSign
            ) &&
            this.billingWarningForm.id == 0
          ) {
            this.billingWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate() {
      tableBillingWarningVue.$api.briefReport
        .selectTemplate({
          monitorIndex: this.billingWarningForm.monitorIndex,
          relationshipSign: this.billingWarningForm.relationshipSign,
          monitorModule: this.monitorModule,
          noticeType: this.billingWarningForm.noticeType
        })
        .then(res => {
          this.billingWarningForm.wechatModal = res.data.briefReportBodyWechat;
          this.billingWarningForm.emailModal = res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectnoticeType() {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (var i = 0; i < this.billingWarningForm.noticeType.length; i++) {
        if (this.billingWarningForm.noticeType[i] == "0") {
          this.isShowEmail = true;
          this.noticeType = this.billingWarningForm.noticeType;
          tableBillingWarningVue.selectTemplate();
        }
        if (this.billingWarningForm.noticeType[i] == "1") {
          this.noticeType = this.billingWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableBillingWarningVue.selectTemplate();
        } else if (this.billingWarningForm.noticeType[i] != "1") {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat() {
      for (var i = 0; i < this.billingWarningForm.noticeType.length; i++) {
        if (this.billingWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.billingWarningForm.contactType
          };
          // 联系方式为 -联系人-
          if (this.billingWarningForm.contactType == 0) {
            weChatDate.userIds = this.billingWarningForm.userIdList;
          }
          // 联系方式为 -联系人组-
          else if (this.billingWarningForm.contactType == 1) {
            weChatDate.contactGroupIds = this.billingWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then(res => {
              if (res.data) {
                // 可以添加告警
                this.wechatWarningVisible = false;
                this.isAddOrEdit = false;
              } else {
                // 不可以添加微信告警
                this.wechatWarningVisible = true;
                this.isAddOrEdit = true;
              }
            });
        } else if (this.billingWarningForm.noticeType[i] != 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups() {
      this.$api.contactGroup
        .listContactGroupsByAccountId(
          "accountId",
          this.billingWarningForm.account
        )
        .then(res => {
          this.contactGroupIdList = res.data;
        });
    },
    // 根据账户组查联系人组
    accountContactGroup() {
      this.$api.contactGroup
        .listContactGroupsByAccountGroupId(
          "accountGroupId",
          this.billingWarningForm.accountGroupName
        )
        .then(res => {
          this.contactGroupIdList = res.data;
        });
    },
    // 切换联系人组
    changeContactGroupId() {
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换通知对象
    changeNotificationObject(val) {
      this.billingWarningForm.userIdList = [];
      this.billingWarningForm.notificationObject = val;
      for (
        var i = 0;
        i < this.billingWarningForm.notificationObject.length;
        i++
      ) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.billingWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.billingWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换联系方式
    changeContactType() {
      this.checkLeastOnePersonBoundWeChat();
    },

    /**************************************  查询  **************************************/
    //查询云平台
    getAccountType(accountType) {
      this.$api.account
        .queryCloudPlatformsByCurrentUser(
          "userName",
          getCookie(global.cookieName)
        )
        .then(res => {
          this.accountTypeList = res.data;
          this.billingWarningForm.accountTypeSearchKey = accountType;
          tableBillingWarningVue.searchMonitorIndex(accountType);
          tableBillingWarningVue.selectAccountByCloudPlatform(accountType);
        });
    },
    //选择云平台
    searchAccountType(accountType) {
      this.billingWarningForm.monitorIndex = "";
      this.monitorIndexList = [];
      this.billingWarningForm.backupRegion = "";
      this.backupRegionList = [];
      // 查询监控指标
      tableBillingWarningVue.searchMonitorIndex(accountType);
      tableBillingWarningVue.selectAccountByCloudPlatform(accountType);
      if (accountType == 0 || accountType) {
        tableBillingWarningVue.getAccountGroupList();
      }
    },
    // 查询云平台下所有账户
    selectAccountByCloudPlatform(accountType) {
      if (this.billingWarningForm.accountTypeSearchKey == undefined) {
        return;
      }
      if (accountType == undefined) {
        return;
      }
      this.$api.account
        .selectAccountByCloudPlatform("type", accountType)
        .then(res => {
          this.accountList = res.data;
          //this.billingWarningForm.account = accountType;
        });
    },
    //  切换类型
    changeTypes(e) {
      this.billingWarningForm.account = "";
      this.billingWarningForm.backupRegion = [];
      this.billingWarningForm.monitorIndex = "";
      this.monitorIndexList = [];
      // 查询监控指标
      tableBillingWarningVue.selectAccountByCloudPlatform(e);
      tableBillingWarningVue.searchMonitorIndex();
    },
    // 查询资源类型
    searchResourceType(accountType, resourceType) {
      if (accountType == undefined) {
        accountType = 0;
      }
      tableBillingWarningVue.$api.billing
        .searchResourceType(
          "cloudType",
          accountType,
          "userName",
          getCookie(global.cookieName)
        )
        .then(res => {
          this.resourceTypeList = res.data;
          this.billingWarningForm.resourceType = resourceType || this.resourceTypeList[0].id;
          this.searchMonitorIndexFix(accountType);
        });
    },
    // 切换资源类型
    handleChangeResourceType(accountType) {
      this.billingWarningForm.monitorIndex = "";
      this.monitorIndexList = [];
      this.searchMonitorIndexFix(accountType);
    },
    // 查询监控指标修复bug
    searchMonitorIndexFix(accountType) {
      if (
        this.billingWarningForm.accountTypeSearchKey == undefined ||
        this.billingWarningForm.types == undefined ||
        this.billingWarningForm.resourceType == undefined
      ) {
        return;
      }
      tableBillingWarningVue.$api.billing
        .searchBillMonitorIndex({
          type: this.billingWarningForm.accountTypeSearchKey,
          billingType: this.billingWarningForm.types,
          resourceType: this.billingWarningForm.resourceType
        })
        .then(res => {
          // 隐藏已下线的废弃指标
          this.monitorIndexList = filterOutDeprecatedMetrics(res.data || []);
        });
    },
    // 查询监控指标
    searchMonitorIndex(accountType) {
      if (
        this.billingWarningForm.accountTypeSearchKey == undefined ||
        this.billingWarningForm.types == undefined ||
        this.billingWarningForm.resourceType == undefined
      ) {
        return;
      }
      this.searchResourceType(accountType);
      tableBillingWarningVue.$api.billing
        .searchBillMonitorIndex({
          type: this.billingWarningForm.accountTypeSearchKey,
          billingType: this.billingWarningForm.types,
          resourceType: this.billingWarningForm.resourceType
        })
        .then(res => {
          // 隐藏已下线的废弃指标
          this.monitorIndexList = filterOutDeprecatedMetrics(res.data || []);
        });
    },
    // 查询通知对象
    queryContacts() {
      tableBillingWarningVue.$api.contact
        .queryContactsByAccountIdAndMonitorModule({
          monitorModule: this.monitorModule,
          accountId: this.billingWarningForm.account
        })
        .then(res => {
          this.notificationObjectList = res.data.contactList;
          this.billingWarningForm.notificationObject =
            res.data.defaultContactIds;
        });
    },
    // 查询账户组
    queryContactGroup() {
      tableBillingWarningVue.$api.contact
        .queryContactsByAccountIdAndMonitorModule({
          accountId: this.billingWarningForm.accountGroupName,
          billingType: 1,
          monitorModule: this.monitorModule
        })
        .then(res => {
          this.notificationObjectList = res.data.contactList;
          this.billingWarningForm.notificationObject =
            res.data.defaultContactIds;
        });
    },
    // 查询报警方式
    alarmWay() {
      tableBillingWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then(res => {
          this.alarmWayList = res.data;
        });
    },
    // 周期
    changeCycle() {
      // 查询阈值
      tableBillingWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle() {
      // 查询阈值
      tableBillingWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue() {
      // 查询阈值
      tableBillingWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign() {
      // 查询阈值
      tableBillingWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableBillingWarningVue.selectTemplate();
    },
    // 根据用户名查询Account列表
    getAccount(accountType) {
      // 查询报警方式
      tableBillingWarningVue.alarmWay();
      // 查询资源类型
      tableBillingWarningVue.searchResourceType(accountType);

      // 查询报警延时
      tableBillingWarningVue.getAlarmDelay();
      //监控时段
      tableBillingWarningVue.searchMonitorPeriod();
      // 查询云平台
      tableBillingWarningVue.getAccountType(accountType);

      // 查询阈值
      tableBillingWarningVue.selectMonitorIndexDefault();
      // 监控模块查询关联的机器人列表
      tableBillingWarningVue.listEnterpriseWechatRobotsByMonitorModule();
    },
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule() {
      tableBillingWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule({
          monitorModule: this.monitorModule
        })
        .then(res => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay() {
      tableBillingWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then(res => {
          this.alarmDelayList = res.data;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod() {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then(res => {
          this.monitorPeriodList = res.data;
        });
    },
    // 选择账户
    changeAccount() {
      if (
        this.billingWarningForm.account == "" ||
        this.billingWarningForm.account == null
      ) {
        return;
      }
      this.billingWarningForm.backupRegion = [];
      tableBillingWarningVue.$api.account
        .queryAccountRegions("accountId", this.billingWarningForm.account)
        .then(res => {
          this.backupRegionList = res.data;
        });
      // 查询通知对象
      tableBillingWarningVue.queryContacts();
      // 查询联系人组
      tableBillingWarningVue.listContactGroups();
      // 查询审批流
      if (
        this.companyId == 1 &&
        this.billingWarningForm.monitorIndex != undefined &&
        this.billingWarningForm.monitorIndex != ""
      ) {
        // 查询当前指标的审批流
        tableBillingWarningVue.listProcessTemplatesByMetricIndex();
      }
    },
    // 选择账户组
    changeAccountGroup() {
      if (
        this.billingWarningForm.accountGroupName == "" ||
        this.billingWarningForm.accountGroupName == null
      ) {
        return;
      }
      this.billingWarningForm.backupRegion = [];
      // 查询通知对象(联系人)
      tableBillingWarningVue.queryContactGroup();
      // 查询联系人组（联系人组）
      tableBillingWarningVue.accountContactGroup();
      // 查询审批流
      if (
        this.companyId == 1 &&
        this.billingWarningForm.monitorIndex != undefined &&
        this.billingWarningForm.monitorIndex != ""
      ) {
        // 查询当前指标的审批流
        tableBillingWarningVue.listProcessTemplatesByMetricIndex();
      }
    },
    /***********存储区域**************************/
    selectBackupRegionAll() {
      this.billingWarningForm.backupRegion = [];
      if (this.singleBackupRegion) {
        this.backupRegionList.map(item => {
          this.billingWarningForm.backupRegion.push(item.name);
        });
      } else {
        this.billingWarningForm.backupRegion = [];
      }
    },
    // 切换存储区域
    changebackupRegion(val) {
      if (val.length === this.backupRegionList.length && val.length != 0) {
        this.singleBackupRegion = true;
      } else {
        this.singleBackupRegion = false;
      }
    },
    // 创建报警
    /**********************************************************************************/
    ok(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var alertList = {
            alertRuleName: this.billingWarningForm.ruleName,
            monitorIndex: this.billingWarningForm.monitorIndex,
            cycle: this.billingWarningForm.cycle,
            continousCycle: this.billingWarningForm.continousCycle,
            statisticsValue: this.billingWarningForm.statisticsValue,
            relationshipSign: this.billingWarningForm.relationshipSign,
            monitorModule: this.monitorModule,
            noticeType: this.billingWarningForm.noticeType,
            billingType: this.billingWarningForm.types,
            unit: this.units,
            delay: this.billingWarningForm.alarmDelay,
            monitorPeriod: this.billingWarningForm.monitorPeriod,
            contactType: this.billingWarningForm.contactType,
            enterpriseWechatRobotIds: this.billingWarningForm
              .enterpriseWechatRobotIds,
            billingDTOList: []
          };
          var billingDTO = {
            type: this.billingWarningForm.types,
            accountType: this.billingWarningForm.accountTypeSearchKey,
            resourceType: this.billingWarningForm.resourceType
          };
          // 单账户
          if (this.billingWarningForm.types == 0) {
            billingDTO.accountId = this.billingWarningForm.account;
            billingDTO.regions = this.billingWarningForm.backupRegion;
          } else if (this.billingWarningForm.types == 1) {
            billingDTO.accountGroupId = this.billingWarningForm.accountGroupName
          }
          alertList.billingDTOList.push(billingDTO);
          if (this.billingWarningForm.monitorIndex == 40) {
            alertList.thresholdValues = this.billingWarningForm.thresholdValues;
          } else {
            alertList.thresholdValue = this.billingWarningForm.thresholdValue;
          }
          // RI利用率和覆盖率告警
          if (this.billingWarningForm.monitorIndex === 1539 || this.billingWarningForm.monitorIndex === 1540) {
            alertList.checkCycle = this.billingWarningForm.checkCycle;
          }

          // 如果联系方式是联系人 传通知对象
          if (this.billingWarningForm.contactType == 0) {
            alertList.contactIDs = this.billingWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.billingWarningForm.contactType == 1) {
            alertList.contactGroupIds = this.billingWarningForm.contactGroupIds;
          }

          // 如果监控指标为EIP没有EC2attached 或者 自动购买预留实例时 传审批流
          if (
            this.billingWarningForm.monitorIndex == 36 ||
            this.billingWarningForm.monitorIndex == 40
          ) {
            alertList.processTemplateId = this.billingWarningForm.approvalFlow;
          }

          if (this.billingWarningForm.id > 0) {
            alertList.id = this.billingWarningForm.id;
            // 编辑告警
            this.addloading = true;
            tableBillingWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.billingWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("common.editSuccess"));
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addloading = true;
            tableBillingWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.billingWarningForm.notificationObject = [];
                  this.thresholdValuesList = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("common.addSuccess"));
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.billingWarningForm.id > 0) {
            this.$Message.error(this.$t("common.editFail"));
          } else {
            this.$Message.error(this.$t("common.addFail"));
          }
        }
      });
    },
    // 取消
    cancel(name) {
      this.wechatWarningVisible = false;
      this.isAddOrEdit = true;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.thresholdValuesList = [];
      this.billingWarningForm.notificationObject = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      this.modal = false;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/monitor/billing/AddOrUpdateBillingWarning.vue